import { useQuery } from '@tanstack/react-query';
import { type Basemap, type BasemapStyle, loadBasemapStyle } from '../../lib/basemap';

/**
 * Loads the basemap style before the map is constructed.
 *
 * Mapbox styles need a fix-up that can only be applied to the style document
 * (see `loadBasemapStyle`), so the style is fetched here rather than handing
 * MapLibre a URL and letting it fetch its own. Cached for the session — the
 * style never changes while the app is open.
 */
export function useBasemapStyle(basemap: Basemap, mapboxToken: string) {
  return useQuery<BasemapStyle>({
    // Keyed on the basemap's id, not just its provider: all three Mapbox
    // basemaps share a provider, and keying on that alone would hand the map
    // the previously-loaded style document every time the viewer switched.
    queryKey: ['basemap-style', basemap.id, basemap.provider, mapboxToken],
    queryFn: () => loadBasemapStyle(basemap, mapboxToken),
    staleTime: Infinity,
    retry: 1,
  });
}
